<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap; margin-top: 10px">
      <div class="search_list">
        <div class="text">结算状态:</div>
        <Select
          v-model="parameter.state"
          @on-change="
            pageNow = 1;
            getData();
          "
          class="select"
        >
          <Option value="1">待确认</Option>
          <Option value="2">已完成</Option>
          <Option value="3">结算额外佣金</Option>
          <Option value="4">已作废</Option>
          <Option value="5">待激活面签</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">信用卡进件状态:</div>
        <Select
          v-model="parameter.applyStatus"
          @on-change="
            pageNow = 1;
            getData();
          "
          class="select"
          ><Option value="0">订单初始化</Option>
          <Option value="1">初审失败</Option>
          <Option value="2">初审通过</Option>
          <Option value="3">激活成功</Option>
          <Option value="4">已首刷</Option>
          <Option value="5">终审失败</Option>
          <Option value="6">终审成功</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">用户(代理)名称/手机号:</div>
        <Input
          v-model="parameter.username"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">办理人名称:</div>
        <Input
          v-model="parameter.name"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">办理人手机号:</div>
        <Input
          v-model="parameter.phone"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">办理人证件号码:</div>
        <Input
          v-model="parameter.pinCodes"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">产品名称:</div>
        <Input
          v-model="parameter.productName"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">团队名称:</div>
        <Input
          v-model="parameter.groupName"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">渠道群名称:</div>
        <Input
          v-model="parameter.outsideGroupName"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">渠道产品名称:</div>
        <Input
          v-model="parameter.outsideProductName"
          @on-change="
            pageNow = 1;
            getData();
          "
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">加入时间查询:</div>
        <DatePicker
          style="width: 300px"
          type="daterange"
          split-panels
          class="select"
          @on-change="queryTime"
        ></DatePicker>
      </div>
      <div class="search_list">
        <div class="text">申请时间查询:</div>
        <DatePicker
          style="width: 300px"
          type="daterange"
          split-panels
          class="select"
          @on-change="queryTime1"
        ></DatePicker>
      </div>
      <div class="search_list">
        <a
          style="
            color: #fff;
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            margin-right: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
            width: 50px;
            display: inline-table;
          "
          :href="url"
          >导出</a
        >
      </div>
    </div>
    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="state">
        <div v-if="row.state == 1">待确认</div>
        <div v-if="row.state == 2">已完成</div>
        <div v-if="row.state == 3">结算额外佣金</div>
        <div v-if="row.state == 4">已作废</div>
        <div v-if="row.state == 5">待激活面签</div>
      </template>
      <template slot-scope="{ row, index }" slot="applyStatus">
        <div v-if="row.applyStatus == 0">订单初始化</div>
        <div v-if="row.applyStatus == 1">初审失败</div>
        <div v-if="row.applyStatus == 2">初审通过</div>
        <div v-if="row.applyStatus == 3">激活成功</div>
        <div v-if="row.applyStatus == 4">已首刷</div>
        <div v-if="row.applyStatus == 5">终审失败</div>
        <div v-if="row.applyStatus == 6">终审成功</div>
      </template>
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >删除</Button
        >
      </template>
    </Table>
    <Modal width="500" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="(title = '删除')">删除</div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      userList: { list: [] },
      title: "",
      upData: {},
      url: "",
      Show: false,
      parameter: {
        pageNow: 1,
      },
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id",
          width: 100,
        },
        {
          title: "办理人姓名",
          className: "fontcolor",
          align: "center",
          key: "name",
          width: 150,
        },
        {
          title: "办理人手机号",
          className: "fontcolor",
          align: "center",
          key: "phone",
          width: 200,
        },
        {
          title: "办理人证件号码",
          className: "fontcolor",
          align: "center",
          key: "pincodes",
          width: 200,
        },
        {
          title: "系统产品名称",
          className: "fontcolor",
          align: "center",
          key: "productName",
          width: 200,
        },
        {
          title: "渠道群名称",
          className: "fontcolor",
          align: "center",
          key: "outsideGroupName",
          width: 200,
        },
        {
          title: "加入时间",
          className: "fontcolor",
          align: "center",
          key: "createTime",
          width: 200,
        },
        {
          title: "创建时间",
          className: "fontcolor",
          align: "center",
          key: "creationTime",
          width: 200,
        },

        {
          title: "结算时间",
          className: "fontcolor",
          align: "center",
          key: "arriveTime",
          width: 200,
        },
        {
          title: "办理状态",
          className: "fontcolor",
          align: "center",
          slot: "state",
          width: 200,
        },
        {
          title: "订单状态",
          className: "fontcolor",
          align: "center",
          slot: "applyStatus",
          width: 200,
        },
        {
          title: "订单状态更新时间",
          className: "fontcolor",
          align: "center",
          key: "statusUpdateTime",
          width: 200,
        },
        {
          title: "订单号",
          className: "fontcolor",
          align: "center",
          key: "orderId",
          width: 200,
        },
        {
          title: "结算金额",
          className: "fontcolor",
          align: "center",
          key: "commission",
          width: 200,
        },

        {
          title: "渠道产品",
          className: "fontcolor",
          align: "center",
          key: "outsideProductName",
          width: 200,
        },
        {
          title: "代理人名称",
          className: "fontcolor",
          align: "center",
          key: "username",
          width: 200,
        },
        {
          title: "团队名称",
          className: "fontcolor",
          align: "center",
          key: "groupName",
          width: 200,
        },
        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right",
          width: 100,
        },
      ],
    };
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    UaorderShip() {
      if (this.title == "删除") {
        api.OutsideOrderDel(this.upData.id).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },
    queryTime(time) {
      this.parameter.startMillisecond =
        Date.parse(new Date(time[0])) - 28800000;
      this.parameter.endMillisecond =
        Date.parse(new Date(time[1])) - 28800000 + 86400000;
      this.$forceUpdate();
      this.getData();
    },
    queryTime1(time) {
      this.parameter.applyStartMillisecond =
        Date.parse(new Date(time[0])) - 28800000;
      this.parameter.applyEndMillisecond =
        Date.parse(new Date(time[1])) - 28800000 + 86400000;
      this.$forceUpdate();
      this.getData();
    },
    getData() {
      api.OutsideOrderQueryList(this.parameter).then((res) => {
        this.userList = res.body.data;
        this.userList.list.forEach((element) => {
          element.commission = (element.commission / 100).toFixed(2);
        });
      });
      this.url = `/api/v1/outside-order/exportExcel?state=${
        this.parameter.state ? this.parameter.state : ""
      }&applyStatus=${
        this.parameter.applyStatus ? this.parameter.applyStatus : ""
      }&username=${
        this.parameter.username ? this.parameter.username : ""
      }&name=${this.parameter.name ? this.parameter.name : ""}&phone=${
        this.parameter.phone ? this.parameter.phone : ""
      }&startMillisecond=${
        this.parameter.startMillisecond ? this.parameter.startMillisecond : ""
      }&endMillisecond=${
        this.parameter.endMillisecond ? this.parameter.endMillisecond : ""
      }&pinCodes=${
        this.parameter.pinCodes ? this.parameter.pinCodes : ""
      }&productName=${
        this.parameter.productName ? this.parameter.productName : ""
      }&groupName=${
        this.parameter.groupName ? this.parameter.groupName : ""
      }&outsideGroupName=${
        this.parameter.outsideGroupName ? this.parameter.outsideGroupName : ""
      }&outsideProductName=${
        this.parameter.outsideProductName
          ? this.parameter.outsideProductName
          : ""
      }&applyStartMillisecond=${
        this.parameter.applyStartMillisecond
          ? this.parameter.applyStartMillisecond
          : ""
      }&applyEndMillisecond=${
        this.parameter.applyEndMillisecond
          ? this.parameter.applyEndMillisecond
          : ""
      }`;
    },
  },
};
</script>

<style scoped>
</style>